import { Component, Inject, OnInit, SecurityContext } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, Validators } from '@angular/forms';

export interface DialogData {
  title: string;
  text: string;
  okText: string;
  inputTitle?: string;
  inputRequired?: boolean;
}

@Component({
  selector: 'iaud-ok-cancel-dialog',
  templateUrl: './ok-cancel-dialog.component.html',
  styleUrls: ['./ok-cancel-dialog.component.scss']
})
export class OkCancelDialogComponent implements OnInit {
  description: FormControl = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<OkCancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.data.title = this.sanitizer.sanitize(SecurityContext.HTML, this.data.title);
    this.data.text = this.sanitizer.sanitize(SecurityContext.HTML, this.data.text);
    this.data.okText = this.sanitizer.sanitize(SecurityContext.HTML, this.data.okText);
    if (this.data.inputRequired) {
      this.description.setValidators(Validators.required);
    }
  }

  onNoClick(): void {
    this.dialogRef.close(this.falseValue());
  }
  falseValue(): any {
    if (this.data.inputTitle) {
      return {
        result: false,
        input: this.description.value,
      };
    }

    return false;
  }
  getValue(): any {
    if (this.data.inputTitle) {
      return {
        result: true,
        input: this.description.value,
      };
    }

    return true;
  }
}
